// extracted by mini-css-extract-plugin
module.exports = {"ManageErpAgentPage":"ManageErpAgentPage_ManageErpAgentPage__2Gi1h","sidebar":"ManageErpAgentPage_sidebar__2C2wU"};